// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__31-M9","name":"ConsentHeader_name__3h9uM","birthday":"ConsentHeader_birthday__UDp92","skeleton":"ConsentHeader_skeleton__1cj4P"};